import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { CzMaxPrice } from './CzMaxPrice';
import { ErrorResponse } from './ErrorResponse';
import { mapCzMaxPrice } from './mapCzMaxPrice';
import { ProductUpdate } from './ProductUpdate';

export interface Result {
	czMaxPrice: CzMaxPrice;
}

export function updateCzMaxPrice(
	client: ApiClient,
	userId: string,
	groupId: string,
	packageSize: number | null,
	referenceBasketVersion: string,
	products: ProductUpdate[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-max-price');

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
			body: JSON.stringify({
				reference: {
					packageSize,
					referenceBasketVersion,
				},
				products: products.map((product) => ({
					id: product.id,
					priceTypeForCalculation: product.priceTypeForCalculation,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					selected: product.selected,
				})),
			}),
		})
		.then((response) => response.json())
		.then((response) => ({
			czMaxPrice: mapCzMaxPrice(response.czMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
